import { Injectable, inject } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { AiService } from './ai.service';

@Injectable({
  providedIn: 'root',
})
export class ChatAttachmentService {
  private readonly aiService = inject(AiService);
  private readonly objectUrlCache = new Map<string, Promise<string>>();
  private readonly resolvedObjectUrls = new Map<string, string>();

  getObjectUrl(id: string): Promise<string> {
    const cached = this.objectUrlCache.get(id);
    if (cached) return cached;

    const objectUrlPromise = lastValueFrom(
      this.aiService.getChatAttachmentBlob(id)
    )
      .then((blob) => {
        const objectUrl = window.URL.createObjectURL(blob);
        this.resolvedObjectUrls.set(id, objectUrl);
        return objectUrl;
      })
      .catch((error) => {
        this.objectUrlCache.delete(id);
        throw error;
      });

    this.objectUrlCache.set(id, objectUrlPromise);
    return objectUrlPromise;
  }

  revokeAll(): void {
    this.resolvedObjectUrls.forEach((objectUrl) =>
      window.URL.revokeObjectURL(objectUrl)
    );
    this.resolvedObjectUrls.clear();
    this.objectUrlCache.clear();
  }
}
